// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-md {
  margin: 0px;
  border-radius: 2px;
  width: 100%;
  font-size: 1.4rem;
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.card-ios {
  margin: 0px;
  border-radius: 2px;
  width: 100%;
  font-size: 1.4rem;
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.list-ios > .item-block:first-child {
  border-top: none !important;
}

.list-ios > .item-block:last-child,
.list-ios > .item-wrapper:last-child .item-block {
  border-bottom: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/trip-information/trip-chat/trip-chat.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EAGA,+GAAA;AAAF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EAGA,+GAAA;AAFF;;AAMA;EACE,2BAAA;AAHF;;AAMA;;EAEE,8BAAA;AAHF","sourcesContent":[".card-md {\n  margin: 0px;\n  border-radius: 2px;\n  width: calc(100%);\n  font-size: 1.4rem;\n  background: #fff;\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.card-ios {\n  margin: 0px;\n  border-radius: 2px;\n  width: calc(100%);\n  font-size: 1.4rem;\n  background: #fff;\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.list-ios > .item-block:first-child {\n  border-top: none !important;\n}\n\n.list-ios > .item-block:last-child,\n.list-ios > .item-wrapper:last-child .item-block {\n  border-bottom: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
